import firedux from '../firedux'
import moment from 'moment'

import {
  MESSAGES_ENDPOINT,
  MESSAGE_APPROVAL_STATUSES
} from '../../config/constants'

export default (containerId, messageId) => {
  if (!containerId || !messageId) return

  const ref = firedux.ref.child(MESSAGES_ENDPOINT).child(containerId).child(messageId)

  return ref.update({approvalStatus: MESSAGE_APPROVAL_STATUSES.APPROVED, time: moment().valueOf()})
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/approve_moderated_message.js
 **/